import { TBoxStructure } from 'components/EMManagement/EMManagementId/EasParamsBox/types';
import { TEmManagementByIdResponse } from 'redux/reducers/emManagement/types';
import { ETableStructureType } from 'ui/EasTable/types';
import { EEmEnums } from '../../../redux/reducers/emManagement/constants';

export const headerBoxStructure: TBoxStructure<TEmManagementByIdResponse> = {
	header: [
		// {
		// 	name: 'Full Name',
		// 	selector: 'fullName',
		// 	type: ETableStructureType.STRING,
		// 	editable: false,
		// },
		// {
		// 	name: 'ID',
		// 	selector: 'id',
		// 	type: ETableStructureType.NUMBER,
		// 	editable: false,
		// },
		// {
		// 	name: 'Country',
		// 	selector: 'registeredCountry',
		// 	type: ETableStructureType.COUNTRY_CODE,
		// 	editable: false,
		// },
		// {
		// 	name: 'Official Site',
		// 	selector: 'officialSiteUrl',
		// 	type: ETableStructureType.STRING,
		// 	editable: false,
		// },
	],
	body: [
		{
			name: 'Full Name',
			selector: 'fullName',
			type: ETableStructureType.STRING,
			editable: true,
			show: false,
		},
		{
			name: 'ID',
			selector: 'id',
			type: ETableStructureType.NUMBER,
			editable: false,
			show: false,
		},

		{
			name: 'Registered Address',
			selector: 'registeredAddress',
			type: ETableStructureType.STRING,
			editable: false,
		},
		{
			name: 'Nominated Person Name',
			selector: 'nominatedPerson',
			type: ETableStructureType.STRING,
			editable: true,
		},
		{
			name: 'TIN',
			selector: 'tinNumber',
			type: ETableStructureType.STRING,
			editable: false,
		},
		{
			name: 'Nominated Phone',
			selector: 'phone',
			type: ETableStructureType.STRING,
			editable: true,
		},
		{
			name: 'EU VAT Number',
			selector: 'vatEu',
			type: ETableStructureType.STRING,
			editable: true,
		},
		{
			name: 'Company Description',
			selector: 'companyDescription',
			type: ETableStructureType.STRING,
			editable: true,
		},

		{
			name: 'Client ID',
			selector: 'clientId',
			type: ETableStructureType.COPYABLE_TEXT,
			editable: false,
		},

		{
			name: 'Trade Name',
			selector: 'tradeName',
			type: ETableStructureType.STRING,
			editable: true,
		},
		{
			name: 'Client Secret',
			selector: 'clientSecret',
			type: ETableStructureType.COPYABLE_TEXT,
			editable: false,
		},
		{
			name: 'Disabled At',
			selector: 'disabledAt',
			type: ETableStructureType.DATE,
			editable: false,
		},
		{
			name: 'Nominated Email',
			selector: 'nominatedEmail',
			type: ETableStructureType.STRING,
			editable: true,
		},

		{
			name: 'Created',
			selector: 'created',
			type: ETableStructureType.DATE,
			editable: false,
			show: false,
		},
		{
			name: 'Status',
			selector: 'status',
			type: ETableStructureType.STATUS,
			editable: false,
			show: false,
		},
		{
			name: 'List ofActive Services',
			selector: 'activeServices',
			type: ETableStructureType.STATUS_ARRAY,
			editable: false,
			show: false,
		},
		{
			name: 'Store Web Address',
			selector: 'officialSiteUrl',
			type: ETableStructureType.STRING,
			editable: false,
			show: false,
		},
		{
			name: 'Vat Subscription',
			selector: 'vatSubscription',
			type: ETableStructureType.STRING,
			editable: false,
			show: false,
		},
		{
			name: 'Registered Country Code',
			selector: 'registeredCountry',
			type: ETableStructureType.COUNTRY_NUMBER,
			editable: true,
			show: false,
		},
		{
			name: 'Registered Postal Code',
			selector: 'registeredPostalCode',
			type: ETableStructureType.STRING,
			editable: true,
			show: false,
		},

		{
			name: 'Registered City',
			selector: 'regAddressCity',
			type: ETableStructureType.STRING,
			editable: true,
			show: false,
		},
		{
			name: 'Registered Street and No',
			selector: 'regStreetNo',
			type: ETableStructureType.STRING,
			editable: true,
			show: false,
		},

		{
			name: 'Legal Status',
			selector: 'legalStatus',
			type: ETableStructureType.ARRAY_ID,
			enumName: EEmEnums.LEGAL_STATUS_EU,
			editable: true,
			show: false,
		},
		{
			name: 'Use for Test',
			selector: 'useForTest',
			type: ETableStructureType.BOOLEAN,
			editable: true,
		},

		{
			name: 'EMTA non resident code',
			selector: 'eeNonResidentCode',
			type: ETableStructureType.STRING,
			editable: true,
		},

		{
			name: 'Support Manager',
			selector: 'supportManager',
			type: ETableStructureType.USER,
			editable: true,
			show: false,
		},
	],
	title: 'Main Information',
};
